import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

type IconProps = { className?: string };

export function LightIcon({ className }: IconProps) {
  return (
    <LineIcon className={className}>
      <path d="M12.9289 27.0711C11.0536 25.1957 10 22.6522 10 20C10 17.3478 11.0536 14.8043 12.9289 12.9289C14.8043 11.0536 17.3478 10 20 10C22.6522 10 25.1957 11.0536 27.0711 12.9289C28.9464 14.8043 30 17.3478 30 20C30 22.6522 28.9464 25.1957 27.0711 27.0711C25.1957 28.9464 22.6522 30 20 30C17.3478 30 14.8043 28.9464 12.9289 27.0711Z" />
      <path d="M18.4993 10.5C17.8732 12.2431 17.8505 13.6539 18.1145 15.5165C18.3785 17.379 19.0878 19.1191 20.1624 20.5402C21.237 21.9612 22.634 23.0066 24.1956 23.5582C25.7571 24.1098 27.421 24.1456 28.9993 23.6616" />
      <path d="M20 1V10M20 30V39M34.0697 6.06934L27.5 12.6389M39 20H30M34.0693 34.0695L27.4999 27.5M6.07031 34.0695L12.6398 27.5M1 20H10M6 6L12.5 12.5" />
    </LineIcon>
  );
}

export function WindIcon({ className }: IconProps) {
  return (
    <LineIcon className={className}>
      <path d="M2.03125 10.3815C7.62153 7.58 12.8125 7.18708 20 10.3815C27.1875 13.576 32.3817 13.1847 37.9688 10.3815L33.0046 8.4409" />
      <path d="M2.03125 20C7.62153 17.1985 12.8125 16.8056 20 20C27.1875 23.1944 32.3817 22.8015 37.9688 20L33.0046 18.0594" />
      <path d="M2.03125 29.6185C7.62153 26.8153 12.8125 26.424 20 29.6185C27.1875 32.8129 32.3817 32.42 37.9688 29.6185L33.0046 27.6762" />
    </LineIcon>
  );
}

export function SliderIcon({ className }: IconProps) {
  return (
    <LineIcon className={className}>
      <path d="M9.62742 37.2326V16.4593M9.62742 11.181V2.76747M12.7751 11.181H6.47977M23.1476 28.4073H16.8524M33.5202 11.181H27.2249M20 23.079V2.76747M20 37.2326V28.4073M30.3725 37.2326V16.4593M30.3725 11.181V2.76747" />
    </LineIcon>
  );
}

export function AnchorIcon({ className }: IconProps) {
  return (
    <LineIcon className={className}>
      <path d="M4.5 17V12a7.5 7.5 0 0 1 7.5-7.5h5M23 4.5h5a7.5 7.5 0 0 1 7.5 7.5v5M35.5 23v5a7.5 7.5 0 0 1-7.5 7.5h-5M17 35.5h-5A7.5 7.5 0 0 1 4.5 28v-5" />
      <rect x="1" y="17" width="6" height="6" rx="1" />
      <rect x="17" y="2" width="6" height="6" rx="1" />
      <rect x="33" y="17" width="6" height="6" rx="1" />
      <rect x="17" y="32" width="6" height="6" rx="1" />
    </LineIcon>
  );
}

export function BuildingIcon({ className }: IconProps) {
  return (
    <LineIcon className={className}>
      <path d="M39 37V18.4017L20 3L1 18.4017V37M27 19V37M13 19V37M13 28H27" />
    </LineIcon>
  );
}

export function SparkleIcon({ className }: IconProps) {
  return (
    <LineIcon className={className} viewBox="0 0 32 32">
      <path d="M14.7222 3.86111C14.689 12.2944 18.7856 17.0682 28.1389 17.2778C19.4653 17.2446 15.1631 21.8957 14.7222 30.6944C14.6392 22.3889 10.9285 17.2663 1.30556 17.2778C9.91522 17.1577 14.6903 13.0023 14.7222 3.86111Z" />
    </LineIcon>
  );
}

export function StarIcon({ className }: IconProps) {
  return (
    <LineIcon className={className}>
      <path d="M20 1v11a8 8 0 0 1-8 8H1M39 20H28a8 8 0 0 1-8-8V1M20 39V28a8 8 0 0 0-8-8H1M39 20H28a8 8 0 0 0-8 8v11" />
    </LineIcon>
  );
}

export function HomeSignalIcon({ className }: IconProps) {
  return (
    <LineIcon className={className}>
      <path d="M39 37V18.4017L20 3L1 18.4017V37" />
      <path d="M24.8838 33.9863C23.6225 32.7575 21.9 32 20 32C18.0998 32 16.3765 32.7573 15.1152 33.9863" />
      <path d="M29.0693 29.6904C26.727 27.4081 23.5287 26 20 26C16.471 26 13.2721 27.4078 10.9297 29.6904" />
      <path d="M33.2578 25.3926C29.8343 22.0565 25.1578 20 20 20C14.842 20 10.1648 22.0562 6.74121 25.3926" />
    </LineIcon>
  );
}

export function DiamondIcon({ className }: IconProps) {
  return (
    <LineIcon className={className}>
      <path d="M32.71 5.5 38.38 14.94 20 34.28 1.62 14.94 7.29 5.5Z" />
      <path d="M2 15h36M13 15l6.5-9.5M27 15l-6.5-9.5M7.5 5.5 13 15l7 19M32.5 5.5 27 15l-7 19" />
    </LineIcon>
  );
}

export function KeyIcon({ className }: IconProps) {
  return (
    <LineIcon className={className} viewBox="0 0 30 30">
      <path d="M4.81771 22.1875C4.81771 22.5808 4.89517 22.9702 5.04567 23.3336C5.19618 23.6969 5.41677 24.027 5.69486 24.3051C5.97295 24.5832 6.3031 24.8038 6.66644 24.9543C7.02979 25.1048 7.41922 25.1823 7.8125 25.1823C8.20578 25.1823 8.59521 25.1048 8.95856 24.9543C9.3219 24.8038 9.65205 24.5832 9.93014 24.3051C10.2082 24.027 10.4288 23.6969 10.5793 23.3336C10.7298 22.9702 10.8073 22.5808 10.8073 22.1875C10.8073 21.7942 10.7298 21.4048 10.5793 21.0414C10.4288 20.6781 10.2082 20.348 9.93014 20.0699C9.65205 19.7918 9.3219 19.5712 8.95856 19.4207C8.59521 19.2702 8.20578 19.1927 7.8125 19.1927C7.41922 19.1927 7.02979 19.2702 6.66644 19.4207C6.3031 19.5712 5.97295 19.7918 5.69486 20.0699C5.41677 20.348 5.19618 20.6781 5.04567 21.0414C4.89517 21.4048 4.81771 21.7942 4.81771 22.1875Z" />
      <path d="M26.9792 11.4062L28.776 9.60938L25.7812 6.61458L27.5781 4.81771C27.8958 4.5 28.0743 4.0691 28.0743 3.61979C28.0743 3.17049 27.8958 2.73958 27.5781 2.42188C27.2604 2.10417 26.8295 1.92568 26.3802 1.92568C25.9309 1.92568 25.5 2.10417 25.1823 2.42188L11.1128 16.4914C9.72618 15.6866 8.09413 15.4137 6.52114 15.7237C4.94816 16.0337 3.54171 16.9055 2.56424 18.1763C1.58676 19.4471 1.10504 21.0301 1.20897 22.63C1.3129 24.2299 1.99537 25.7373 3.12903 26.871C4.2627 28.0046 5.77011 28.6871 7.36998 28.791C8.96986 28.895 10.5529 28.4132 11.8237 27.4358C13.0945 26.4583 13.9663 25.0518 14.2763 23.4789C14.5863 21.9059 14.3134 20.2738 13.5086 18.8872L20.3906 12.0052L22.7865 14.401L24.5833 12.6042L22.1875 10.2083L23.9844 8.41146L26.9792 11.4062Z" />
    </LineIcon>
  );
}

export function ArchIcon({ className }: IconProps) {
  return (
    <LineIcon className={className}>
      <path d="M1 21V11C1 5.477 5.477 1 11 1h9M39 21V11C39 5.477 34.523 1 29 1h-9M20 15.5V40" />
    </LineIcon>
  );
}

export function HospitalityMarkIcon({ className }: IconProps) {
  return (
    <LineIcon className={className} viewBox="27 0 28 28">
      <path d="M28.75 12V9.5a8.75 8.75 0 0 1 8.75-8.75h7a8.75 8.75 0 0 1 8.75 8.75V12" />
      <path strokeOpacity={0.3} d="M41 8v19" />
    </LineIcon>
  );
}

// Strokes stay 1px on screen at any rendered size (see .line-icon in index.css).
function LineIcon({
  className,
  viewBox = "0 0 40 40",
  children,
}: IconProps & { viewBox?: string; children: ReactNode }) {
  return (
    <svg
      viewBox={viewBox}
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={cn("line-icon", className)}
    >
      {children}
    </svg>
  );
}
